module.exports = __webpack_public_path__ + "img/album04_08.04c178c6.jpg";